import Else from 'mrf/utils/Else.js'

console.warn("The 'view/ELSE' component is deprecated, please use 'utils/ELSE' instead.")
const ELSE = Else;

export default ELSE;
